import styled from 'styled-components';

export const Container = styled.div<{ isLoading: boolean; }>`
    position: relative;
    opacity: ${props => props.isLoading ? 0 : 1};
    transition: all 300ms ease 0.5s, visibility 0s linear 0s;
`;
